import { useEffect, useState } from "react";
import { motion } from "framer-motion";

export const BgFade = ({ photos, interval = 7000, className = "", testId = "bg" }) => {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % photos.length), interval);
    return () => clearInterval(t);
  }, [photos.length, interval]);
  return photos.map((src, i) => (
    <motion.img
      key={src}
      src={src}
      alt=""
      initial={false}
      animate={{ opacity: i === idx ? 1 : 0 }}
      transition={{ duration: 2.4, ease: "easeInOut" }}
      className={`absolute inset-0 h-full w-full object-cover ${className}`}
      data-testid={`${testId}-${i}`}
    />
  ));
};

export const SectionBackdrop = ({ photos, testId }) => (
  <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden data-testid={testId}>
    <div className="absolute inset-0 opacity-25 lg:left-[45%] lg:opacity-45">
      <BgFade photos={photos} interval={8000} className="object-[50%_25%]" testId={`${testId}-img`} />
    </div>
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_75%_30%,rgb(var(--rc-bg2)/0.2)_0%,rgb(var(--rc-bg2)/0.85)_60%,rgb(var(--rc-bg2))_95%)]" />
    <div className="absolute inset-y-0 left-[45%] hidden w-[30%] bg-gradient-to-r from-rc-bg2 to-transparent lg:block" />
  </div>
);
